<template>
  <v-layout pt-4 pr-2 pb-2 row class="small-book-form">
    <v-flex md10>
      <v-layout>
        <v-flex md6>
          <SimpleCard>
            <v-layout row wrap>
              <v-flex xs12 class="mb-3">
                <h2>
                  Edit Driver
                  <b>{{ user.name }}</b>
                </h2>
              </v-flex>
              <v-flex xs12 pl-1>
                <h3>User</h3>
              </v-flex>
              <v-flex xs12 md12>
                <UserForm
                  ref="userForm"
                  :disabled="false"
                  :user="user"
                  :errors="errors.user"
                  :editingUser="true"
                  @validityChange="updateFormValidity('user', $event)"
                />
                <v-divider class="mx-1"></v-divider>
              </v-flex>
              <v-flex xs12 pl-1 pt-2>
                <h3>Driver</h3>
              </v-flex>
              <v-flex xs12 md12>
                <DriverForm
                  ref="driverForm"
                  :driver="driver"
                  :driver-details="driver_details"
                  :errors="driverErrors"
                  :currentDocuments="currentDriverDocuments"
                  :pictureUrl="pictureUrl"
                  @imageInput="handleImageInput"
                  @documentInput="handleDocumentInput"
                  @validityChange="updateFormValidity('driver', $event)"
                  @deletePicture="handleDeletePicture"
                  @deleteDocument="handleDeleteDocument"
                  @viewDocument="handleViewDocument"
                />
              </v-flex>
              <v-flex xs12 pl-1>
                <h3>Taxi</h3>
              </v-flex>
              <v-flex xs12 md12>
                <SelectTaxi :taxi="taxi" @taxiChange="handleTaxiChange" />
              </v-flex>
              <v-flex xs12 md12 class="py-0">
                <v-layout align-center justify-end row>
                  <v-btn color="success" @click="update" class="text-none"
                  >Update</v-btn
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </SimpleCard>
        </v-flex>
        <v-flex md6>
          <v-col
            cols="12"
            md="12"
            class="px-0 pl-1 py-0"
          >
            <SimpleCard>
              <v-row >
                <v-col cols="12" md="12" lg="12" class="text-center">
                  <v-flex>
                    <v-avatar color="indigo">
                      <v-img :src="pictureUrl"></v-img>
                    </v-avatar>
                  </v-flex>
                  <v-flex>
                    <v-btn class="mt-2" @click="pictureDialog = true" small outlined>Upload New</v-btn>
                    <br>
                    <span class="mt-3" v-if="driver.picture">{{driver.picture.name.substring(driver.picture.name.length - 25)}}</span>
                  </v-flex>
                </v-col>
                <v-col cols="12">
                  <v-divider class="my-4"></v-divider>
                </v-col>
                <v-col cols="12">
                  <v-card-title class="px-0 py-0">Driver Documents
                    <v-spacer></v-spacer>
                    <v-btn small @click="anyDocumentDialog = true">Upload Any Document</v-btn>
                  </v-card-title>
                  <DriverDocumentsBox ref="driverDocs" :driver-id="driverId"></DriverDocumentsBox>
                </v-col>
                <v-col cols="12">
                  <v-btn small text class="blue--text" @click="togglePreviousDocs">{{ !showPreviousDocs ? 'See' : 'Hide' }} all documents</v-btn>
                </v-col>
                <v-col cols="12" v-if="showPreviousDocs">
                  <v-divider></v-divider>
                  <DriverUploadedDocuments :driver-uploaded-documents="currentDriverDocuments"></DriverUploadedDocuments>
                </v-col>
                <v-col cols="12">
                  <v-divider class="my-4"></v-divider>
                </v-col>
                <v-col cols="12" v-if="!loading">
                  <v-card-title class="px-0 py-0">Taxi Documents
                    <v-spacer></v-spacer>
                    <v-btn small @click="anyDocumentDialog = true">Upload Any Document</v-btn>
                  </v-card-title>
                  <TaxiDocumentsBox ref="taxiDocs" :taxi="taxi"></TaxiDocumentsBox>
                </v-col>
              </v-row>
            </SimpleCard>
          </v-col>

        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog
      v-model="pictureDialog"
      width="500"
    >
      <v-card class="pa-3">
        <v-card-title class="headline grey lighten-2">
          Uploaded Profile Picture
          <v-spacer></v-spacer>
          <v-icon @click="pictureDialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-layout row class="text-center">
            <v-flex
              px-2
            >
              <FileInput
                label="Photo"
                icon="photo_camera"
                accept="image/*"
                :required="true"
                :error-message="errorForField('picture')"
                :rules="driverRules.picture"
                @fileInput="handleImageInput"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="anyDocumentDialog"
      width="600"
    >
      <v-card class="pa-3">
        <v-card-title class="headline grey lighten-2">
          Uploaded Any Document
          <v-spacer></v-spacer>
          <v-icon @click="anyDocumentDialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <AnyDocumentUploadBox
              @documentUploaded="refreshDriverPage"
              :driver-id="$route.params.id"
              :taxi-id="this.taxi.id"
              :document-types="documentTypes"/>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbarShow"
      :color="snackbarColour"
      :timeout="4000"
      >{{ snackbarMessage }}</v-snackbar
    >
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import UserForm from "@/components/driver/UserFormV2.vue";
import DriverForm from "@/components/driver/DriverFormV2.vue";
import SelectTaxi from "@/components/driver/SelectTaxiV2.vue";
import FileInput from "@/components/widget/input/FileInput.vue";


import qs from "qs";
import axios from "axios";
import DriverDocumentsBox from './DriverDocumentsBox'
import DriverNewDocumentsBox from './DriverNewDocumentsBox'
import DriverUploadedDocuments from '../../components/document/DriverUploadedDocuments'
import AnyDocumentUploadBox from '../../components/document/AnyDocumentUploadBox'
import TaxiDocumentsBox from '../taxi/TaxiDocumentsBox'
axios.defaults.withCredentials = true;

export default {
  name: "EditDriverV2",
  components: {
    AnyDocumentUploadBox,
    DriverUploadedDocuments,
    DriverNewDocumentsBox,
    DriverDocumentsBox,
    TaxiDocumentsBox,
    SimpleCard,
    UserForm,
    DriverForm,
    SelectTaxi,
    FileInput
  },
  data: function () {
    return {
      documentTypes: [
        {
          name: 'DVLA Drivers badge (front & back)',
          expiryDate: '',
          file: "",
          type: 'dvla_license'
        },
        {
          name: 'Council Compliance Certificate',
          expiryDate: '',
          file: "",
          type: 'compliance_certificate'
        },
        {
          name: 'Vehicle Insurance',
          expiryDate: '',
          file: "",
          type: 'insurance'
        },
        {
          name: 'Proof of address',
          expiryDate: '',
          file: "",
          type: 'proof_of_address'
        },
        {
          name: 'Vehicle Plate',
          expiryDate: '',
          file: "",
          type: 'vehicle_plate'
        },
        {
          name: 'Hackney Carriage or Private Hire Badge',
          expiryDate: '',
          file: "",
          type: 'hackney_license'
        },
        {
          name: 'MOT Certificate',
          expiryDate: '',
          file: "",
          type: 'mot'
        },
        {
          name: 'Operators License',
          expiryDate: '',
          file: "",
          type: 'operators_license'
        },
        {
          name: 'Public Liability Insurance',
          expiryDate: '',
          file: "",
          type: 'public_liability_insurance'
        },
        {
          name: 'Employers Liability Insurance',
          expiryDate: '',
          file: "",
          type: 'employers_liability_insurance'
        },
        {
          name: 'Private Hire License Number',
          expiryDate: '',
          file: "",
          type: 'private_hire_license'
        },
        {
          name: 'Road Tax',
          expiryDate: '',
          file: "",
          type: 'road_tax'
        },
        {
          name: 'Form B',
          expiryDate: '',
          file: "",
          type: 'form_b'
        },
        {
          name: 'DBS',
          expiryDate: '',
          file: "",
          type: 'dbs'
        }
      ],
      pictureDialog: false,
      anyDocumentDialog: false,
      showPreviousDocs: false,
      loading: false,
      user: {},
      driver: {},
      driver_details: {},
      taxi: {},
      currentDriverDocuments: [],
      pictureUrl: "",
      rideTypes: [],
      councils: [],
      errors: {},
      userFormValid: false,
      driverFormValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      driverRules: {
        driving_license_number: [],
        callsign: [
          (v) =>
            !v ||
            (v.length > 0 && v.length < 6) ||
            "Callsign must not exceed 6 digits",
        ],
        hackney_number: [
          (v) =>
            !v ||
            (v.length >= 1 && v.length <= 6) ||
            "Hackney carriage number must be from 3 to 6 digits",
        ],
        private_hire_number: [
          (v) =>
            !v ||
            (v.length >= 1 && v.length <= 6) ||
            "Private hire number must be from 3 to 6 digits",
        ],
        driving_license_expiry: [
          (v) =>
            !v ||
            /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(v) ||
            "Driving license expiry is in an invalid format",
        ],
        hackney_expiry: [],
        private_hire_expiry: [],
        fee_percentage: [
          (v) =>
            !v ||
            (v && parseInt(v) >= 0 && parseInt(v) <= 100) ||
            "Commission Percentage must be between 0 and 100",
        ],
        picture: [],
        documentDescription: [(v) => !!v || "Document description is required"],
      },
  
    };
  },
  mounted: function () {
    this.getTaxiInformation();
    this.getDriverInfo();
  },
  methods: {
    refreshDriverPage() {
      this.$refs.driverDocs.loadDocuments()
      this.$refs.taxiDocs.loadDocuments();
      this.anyDocumentDialog = false
    },
    updateDocumentFile(data) {
      console.log('data for file', data)
      let document = this.documentTypes.find(doc => {
        return doc.type == data.type
      })
      if (document) {
        document.file = data.file
        document.expiryDate = data.expiryDate
      }
    },
    prepareDriverExpiryDocuments () {
      this.documentTypes.forEach(doc => {
        if (doc.file) {
          this.driver.expiryDocuments.push(doc)
        }
      })
    },
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    togglePreviousDocs () {
      console.log(this.showPreviousDocs)
      this.showPreviousDocs = !this.showPreviousDocs
    },
    getTaxiInformation: async function () {
      try {
        let url = `${this.$store.state.apiUrl}/taxi/getCouncilAndRideTypesForCreateTaxi`;
        let response = await axios.get(url, {
          params: {},
        });
        this.rideTypes = response.data.ride_types;
        this.councils = response.data.councils;
      } catch (error) {
        console.log(
          "Failed to get information required to create taxi " + error
        );
      }
    },
    
    getDriverInfo: async function () {
      this.loading = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/driver/${this.$route.params.id}/getForEdit`;

      await axios
        .get(url)
        .then(function (response) {
          if (!response.error) {
            self.populateDriverInfo(response.data);
          } else {
            console.log(response.error);
            //handle error
          }
        })
        .catch(function (error) {
          this.loading = false;
          console.log(error);
          //handle error
        });
    },
    populateDriverInfo: function (data) {
      console.log('prepar', data);
      let newDriver = {
        callsign: data.driver.callsign,
        driving_license_number: data.driver.licence_number,
        hackney_number: data.driver.hackney_number,
        private_hire_number: data.driver.hire_number,
        driving_license_expiry: data.driver.licence_number_renewal_date,
        hackney_expiry: data.driver.hackney_number_renewal_date,
        private_hire_expiry: data.driver.hire_number_renewal_date,
        fee_percentage: data.driver.fee_percentage,
        weekly_charge_amount: (data.driver.weekly_charge_amount / 100),
        pictureUrl: data.pictureURL,
        documents: [],
        expiryDocuments: [],
      };

      let newDriverDetails = {
        address_line_1: data.driver_details.address1,
        address_line_2: data.driver_details.address2,
        town: data.driver_details.town,
        county: data.driver_details.county,
        postcode: data.driver_details.postcode,
        home_phone: data.driver_details.homeNumber,
        b_tech: data.driver_details.btech,
        wheelchair_cert: data.driver_details.wheelChairCertificate,
        nvq: data.driver_details.nvq,
        adt: data.driver_details.adt,
      };

      let newUser = {
        name: data.driver.user.name,
        email: data.driver.user.email,
        contact_number: data.driver.user.contact_number,
        password: "",
      };

      this.driver = newDriver;
      this.driver_details = newDriverDetails;
      this.user = newUser;
      this.currentDriverDocuments = data.documents;
      this.pictureUrl = data.pictureURL;
      this.taxi = data.taxi;

      this.loading = false;
    },
    updateFormValidity: function (form, value) {
      switch (form) {
        case "user":
          this.userFormValid = value;
          break;
        case "driver":
          this.driverFormValid = value;
          break;
      }
    },
    handleImageInput: function (file) {
      this.driver.picture = file;
      this.pictureDialog = false
    },
    handleDocumentInput: function (files) {
      this.driver.documents = files;
    },
    handleDeletePicture: function () {
      this.pictureUrl = "";
    },
    handleDeleteDocument: function (fileID) {
      console.log(fileID);
      this.currentDriverDocuments = this.currentDriverDocuments.filter(
        function (document) {
          return document.id !== fileID;
        }
      );
    },
    handleViewDocument: function (fileID) {
      let documentFile = this.currentDriverDocuments.find(function (document) {
        return document.id === fileID;
      });

      let self = this;
      let url = `${this.$store.state.apiUrl}/driver/getDocumentUrl`;
      axios({
        url: url,
        method: "GET",
        params: {
          key: documentFile.filename,
        },
      })
        .then(function (response) {
          if (response.data.error) {
            console.log(response.data.error);
            self.snackbarMessage = "Failed to retrieve file";
            self.snackbarColour = "error";
            self.snackbarShow = true;
          } else {
            const link = document.createElement("a");
            link.href = response.data.url;
            link.target = "_blank";
            link.setAttribute("download", documentFile.name);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(function (error) {
          console.log(error);
          self.snackbarMessage = "Failed to retrieve file";
          self.snackbarColour = "error";
          self.snackbarShow = true;
        });
    },
    handleTaxiChange: function (newTaxi) {
      this.taxi = newTaxi;
      this.$refs.taxiDocs.loadDocuments();
    },
    update: async function () {

      var drv = JSON.parse(JSON.stringify(this.driver));

        drv.weekly_charge_amount = Math.round( this.driver.weekly_charge_amount * 100 );

        console.log("booop");


      if (this.userFormValid && this.driverFormValid) {
        this.prepareDriverExpiryDocuments()
        let self = this;
        let url = `${this.$store.state.apiUrl}/driver/${this.$route.params.id}/update`;
        axios({
          url: url,
          method: "post",
          data: {
            user: this.user,
            driver: drv,
            driver_details: this.driver_details,
            taxiID: this.taxi.id,
            pictureUrl: this.pictureUrl,
            currentDocuments: this.currentDriverDocuments,
            expiryDocuments: this.driver.expiryDocuments
          },
          headers: {
            "Content-Type": "text/plain",
          },
        })
          .then(function (response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error updating driver, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
                self.snackbarMessage =
                    "Error updating driver: " + response.data.message;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              const driverID = response.data.driver.id;
              self.$snackbar.success('Driver details updated.')
            }
          })
          .catch(function (error) {
            console.log(error);
            self.snackbarMessage = error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.userForm.validateForm();
        this.$refs.driverForm.validateForm();
      }
    },
  },
  computed: {
    driverId () {
      return this.$route.params.id
    },
    driverErrors: function () {
      return {
        ...this.errors.driver,
        ...this.errors.driver_details,
      };
    },
  },
};
</script>